import {useDispatch, useSelector} from "react-redux";
import {selectActiveOrganization} from "../../../../app/store/reducers/auth/authReducer";
import {useParams} from "react-router";
import React, {useEffect, useMemo, useState} from "react";
import {
    loadDraftEmpowermentV2,
    loadEmpowermentV2Async
} from "../../../../app/store/reducers/roaming/roamingEmpowermentV2Reducer";
import EmpowermentV2FillForm from "../../../../components/hippo/roaming/empowerementV2/forms/EmpowermentV2FillForm";
import EventBus from "../../../../app/eventbus/EventBus";
import {
    EMPOWERMENT_V2_DRAFT_FAILED,
    EMPOWERMENT_V2_DRAFT_REQUESTED, EMPOWERMENT_V2_DRAFT_SUCCESS,
    EMPOWERMENT_V2_SEND_FAILED,
    EMPOWERMENT_V2_SEND_REQUESTED,
    EMPOWERMENT_V2_SEND_SUCCESS
} from "../../../../app/eventbus/roaming/roamingEmpowermentV2Events";
import {selectLang, Translate, updateShowInProgressAsync} from "../../../../app/store/reducers/main/mainReducer";
import {toast} from "react-toastify";
import {useHistory} from "react-router-dom";


const FillEmpowermentV2 = () => {
    const activeOrganization = useSelector(selectActiveOrganization);
    const [empowermentV2, setEmpowermentV2] = useState(null);
    const [draftEmpowermentV2, setDraftEmpowermentV2] = useState(null)
    const dispatch = useDispatch()
    const history = useHistory()
    const lang = useSelector(selectLang)
    const {id} = useParams();
    const t = Translate



    const query = useMemo(() => {
        return new URLSearchParams(history.location.search);
    }, [history.location.search])

    useEffect(async () => {
        loadEmpowermentV2()
    },[id, activeOrganization])

    const loadEmpowermentV2 = async () => {
        const status = JSON.parse(query.get("status"));
        if (status) {
            loadEmpowermentV2Async(id)
                .then(loadedEmpowermentV2 => {
                    setEmpowermentV2(loadedEmpowermentV2)
                })
                .catch(errors => {
                    setEmpowermentV2(null)
                    console.log(errors)
                    toast.error(t(lang,"roaming.common.error_not_found"))
                })
        } else {
            loadDraftEmpowermentV2(id)
                .then(getDraft => {
                    setDraftEmpowermentV2(JSON.parse(getDraft?.data?.content))
                })
                .catch(errors => {
                    setDraftEmpowermentV2(null)
                    console.log(errors)
                    toast.error(t(lang,"roaming.common.error_not_found"))
                })
        }
    };


    useEffect(() => {
        const onEmpowermentV2SentRequestedHandler = EventBus.on(EMPOWERMENT_V2_SEND_REQUESTED, () => {
            dispatch(updateShowInProgressAsync(true))
        })

        const onEmpowermentV2SentSuccessHandler = EventBus.on(EMPOWERMENT_V2_SEND_SUCCESS, empowermentV2 => {
            dispatch(updateShowInProgressAsync(false))
            toast.success(t(lang, 'roaming.toast.empowerment_send_success'))
            history.push(`/roaming/empowerment-v2/${empowermentV2.id}`)
        })

        const onEmpowermentV2SentFailedHandler = EventBus.on(EMPOWERMENT_V2_SEND_FAILED, (error) => {
            dispatch(updateShowInProgressAsync(false))
            toast.error(error.message)
        })

        const onEmpowermentV2DraftRequestedHandler = EventBus.on(EMPOWERMENT_V2_DRAFT_REQUESTED, () => {
            dispatch(updateShowInProgressAsync(true))
        })

        const onEmpowermentV2DraftSuccessHandler = EventBus.on(EMPOWERMENT_V2_DRAFT_SUCCESS, empowermentV2Id => {
            dispatch(updateShowInProgressAsync(false))
            toast.success(t(lang, 'roaming.act_form_save_success'))
            history.push(`../../draft-empowerment-v2/${empowermentV2Id.id}`)
        })

        const onEmpowermentV2DraftFailedHandler = EventBus.on(EMPOWERMENT_V2_DRAFT_FAILED, () => {
            dispatch(updateShowInProgressAsync(false))
            toast.success(t(lang, 'roaming.act_form_save_error'))
        })

        return () => {
            EventBus.remove(EMPOWERMENT_V2_SEND_REQUESTED, onEmpowermentV2SentRequestedHandler);
            EventBus.remove(EMPOWERMENT_V2_SEND_SUCCESS, onEmpowermentV2SentSuccessHandler);
            EventBus.remove(EMPOWERMENT_V2_SEND_FAILED, onEmpowermentV2SentFailedHandler);
            EventBus.remove(EMPOWERMENT_V2_DRAFT_REQUESTED, onEmpowermentV2DraftRequestedHandler);
            EventBus.remove(EMPOWERMENT_V2_DRAFT_SUCCESS, onEmpowermentV2DraftSuccessHandler);
            EventBus.remove(EMPOWERMENT_V2_DRAFT_FAILED, onEmpowermentV2DraftFailedHandler);
        }
    },[])

    const draftEmpowermentV2Parse = {
        info: {
            number: draftEmpowermentV2?.EmpowermentDoc?.EmpowermentNo,
            start: draftEmpowermentV2?.EmpowermentDoc?.EmpowermentDateOfIssue,
            end: draftEmpowermentV2?.EmpowermentDoc?.EmpowermentDateOfExpire,
        },
        customer: {
            inn: draftEmpowermentV2?.BuyerTin,
            name: draftEmpowermentV2?.Buyer?.Name,
            director: draftEmpowermentV2?.Buyer?.Director,
            accountant: draftEmpowermentV2?.Buyer?.Accountant,
            bank_name: '',
        },
        executor: {
            inn: draftEmpowermentV2?.SellerTin,
            name: draftEmpowermentV2?.Seller?.Name,
            director: draftEmpowermentV2?.Seller?.Director,
            accountant: draftEmpowermentV2?.Seller?.Accountant,
            bank_name: '',
        },
        person_info: {
            person_inn: draftEmpowermentV2?.Agent?.AgentTin,
            full_name: draftEmpowermentV2?.Agent?.Fio,
        },
        contract: {
            date: draftEmpowermentV2?.ContractDoc?.ContractDate,
            number: draftEmpowermentV2?.ContractDoc?.ContractNo,
        },
        status: true,
        items: draftEmpowermentV2?.ProductList?.Products.map(item => {
            return {
                ordering_number: item?.OrdNo,
                name: item?.Name,
                quantity: item?.Count,
                measure_id: item?.MeasureId,
                catalog: {
                    code: item?.CatalogCode,
                    name: item?.CatalogName,
                }
            }
        })
    }


    if (!empowermentV2 && !draftEmpowermentV2){
        return(
            <>
                loading...
            </>
        )
    } else {
        return(
            <>
                <EmpowermentV2FillForm empowermentV2={empowermentV2 || draftEmpowermentV2Parse} />
            </>
        )
    }
}


export default FillEmpowermentV2;
